import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/buttons';

import { ScShowMoreBtn, ScShowMoreBtnProps } from '../styled';

interface ShowMoreButtonProps extends ScShowMoreBtnProps {
  isShowMoreMode: boolean;
  onClick: () => void;
}
export const ShowMoreButton: FC<ShowMoreButtonProps> = ({
  isShowMoreMode,
  onClick,
  darkMode,
  smallShowBtn,
}) => {
  const { t } = useTranslation('common');

  const btnText = useMemo(() => {
    return t(isShowMoreMode ? 'showMoreShort' : 'showLess');
  }, [isShowMoreMode, t]);

  return (
    <ScShowMoreBtn
      darkMode={darkMode}
      smallShowBtn={smallShowBtn}
      onClick={smallShowBtn ? onClick : undefined}
    >
      {smallShowBtn ? (
        <p className="text-btn">{btnText}</p>
      ) : (
        <Button
          blackTransparent={!darkMode}
          whiteTransparent={darkMode}
          small
          horizontalAlignment
          onClick={onClick}
        >
          {btnText}
        </Button>
      )}
    </ScShowMoreBtn>
  );
};
